import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Lang,
  LANG_STORAGE_KEY,
  RootState,
  setLang as setLangAction,
} from "../store/authStore";
import en, { Dictionary } from "./en";
import id from "./id";

const dictionaries: Record<Lang, Dictionary> = { en, id };

export const useTranslation = () => {
  const dispatch = useDispatch();
  const lang = useSelector((state: RootState) => state.auth.lang);

  const setLang = (next: Lang) => dispatch(setLangAction(next));

  return { lang, t: dictionaries[lang], setLang };
};

// Mount once (in App): keeps <html lang>, the tab title and the saved choice in sync.
export const useLanguageSync = () => {
  const { lang, t } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = t.meta.title;
    try {
      window.localStorage.setItem(LANG_STORAGE_KEY, lang);
    } catch {
      // ignore: preference just won't persist
    }
  }, [lang, t]);
};

export const whatsappLink = (message: string) =>
  `https://wa.me/6281113423251?text=${encodeURIComponent(message)}`;

export type { Lang, Dictionary };
